import React from 'react';
import { Redirect, Route, Switch, Link } from 'react-router-dom';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import Spin from 'components/common/Spin';
import Todo from '../modules/student/todo';
import Timeline from '../modules/student/timeline';
import Team from '../modules/student/team';
import Stats from '../modules/student/stats';
import Worksheets from '../modules/student/worksheets/Worksheets';
import ExerciseFrom from '../modules/student/worksheets/ExerciseForm';
import SnapshotTable from './snapshot';
import Essays from '../modules/student/essays';
import School from '../modules/student/school';
import Meeting from './twilio/VideoChat';
import Profile from '../modules/student/profile';
import CommonApp from '../modules/student/common-app';
import client from '../graphql/client';
import { setStudentProfile } from '../reducers/student';
import { GET_STUDENT_PROFILE } from '../graphql/student/Profile';
import Navigation from 'modules/student/components/header';
import NotificationPage from './pages/notification/Page';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AlertTitle from '@material-ui/lab/AlertTitle';
import ProfileOnBoarding from 'modules/student/onboarding';
import Fab from '@material-ui/core/Fab';
import ForumIcon from '@material-ui/icons/Forum';
import Cookies from 'universal-cookie';
import FinancialAidIcon from 'assets/sidebar/icon-financial-aid';
import FinancialAid from '../modules/parent/financial-aid';
import Referral from '../modules/referral';
import FileManager from '../modules/file-manager';
import Layout from './Layout';
import {
  SoloStudentSidebar,
  StudentSidebar,
  CohortStudentSidebar,
} from '../constant';
import Upsell from '../modules/parent/upsell';
import WelcomeVideo from '../modules/student/components/video';
import { Query } from '@apollo/react-components';
import { GET_STATUSES } from 'graphql/student/stats';
import { toUserTimezone } from 'utils';
import SharePopup from 'components/social-share/SharePopup';
import {useHistory} from 'react-router-dom';

const styles = (theme) =>
  createStyles({
    container: {
      height: '100%',
      minHeight: '100vh',
      display: 'flex',
      flexWrap: 'nowrap',
    },
    fab: {
      position: 'fixed',
      right: 20,
      bottom: 20,
      zIndex: 1000,
    },
  });

const cookies = new Cookies();

class Student extends React.Component {
  state = {
    selectedItem: this.props.history.location.pathname,
    loading: true,
    onBoardingSkip: 'true',
    redirect: false,
    showChat: false,
    expanded: false,
    showVideo: false,
  };

  async componentDidMount() {
    const show = cookies.get('welcome_video');
    

    if (!show) {
      this.setState({ showVideo: true });
      cookies.set('welcome_video', '1', {
        path: '/',
        expires: new Date(2099, 1, 1),
      });
    }
    const { setStudentProfile, user } = this.props;
    client
      .query({
        query: GET_STUDENT_PROFILE,
        variables: {
          id: user.id,
        },
      })
      .then(({ data }) => {
        setStudentProfile(data.student_profile[0]);
      })
      .then(async () => {
        const { profile } = this.props;
        await this.checkOnBoardingSkip(profile);
      });
  }

  componentDidUpdate = () => {
    if (cookies.get('onboarding_skip') !== String(this.state.onBoardingSkip)) {
      if (!cookies.get('onboarding_skip')) {
        cookies.set('onboarding_skip', this.state.onBoardingSkip);
      }
      this.setState({
        onBoardingSkip: cookies.get('onboarding_skip'),
      });
    }
  };

  checkOnBoardingSkip = async (profile) => {
    if (!profile.onboarding_done) {
      let onboarding_skip = await cookies.get('onboarding_skip');
      if (onboarding_skip === 'false') {
        await this.setState({ onBoardingSkip: 'false', redirect: true }, () =>
          this.props.history.push('/onboarding'),
        );
      }
    } else {
      cookies.set('onboarding_skip', true);
    }
    this.setState({ loading: false });
  };

  toggleChat = () => {
    this.setState({ showChat: !this.state.showChat });
  };

  toggleMenu = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };

  render() {
    const { onBoardingSkip, showVideo } = this.state;
    const {
      classes,
      profile,
      history: {
        location: { pathname },
      },
      user,
    } = this.props;
    if (!profile.id) return <Spin spinning linear />;

    if (!profile.onboarding_done && onBoardingSkip === 'false')
      return (
        <Box className={classes.container}>
          <Switch>
            <Route
              path={'/onboarding'}
              render={() => (
                <ProfileOnBoarding {...this.props} sub={this.props.sub} />
              )}
            />
          </Switch>
        </Box>
      );

    if (profile.product_type === 'group' && !profile.group) {
      return (
        <Layout
          role="student"
          navigations={StudentSidebar}
          renderHeader={({ toggleMenu }) => (
            <Navigation
              showChat={this.state.showChat}
              toggleChat={this.toggleChat}
              toggleMenu={toggleMenu}
            />
          )}
        >
          <Grid container spacing={3}>
            <Alert color={'info'}>
              You are not assigned to any group. Please contact support.
            </Alert>
          </Grid>
        </Layout>
      );
    }

    const trialExpired = profile.is_trial
      ? moment(profile.trial_end_date).isBefore(new Date(), 'day')
      : false;

    if (trialExpired) {
      return (
        <Layout
          role="student"
          navigations={StudentSidebar}
          renderHeader={({ toggleMenu }) => (
            <Navigation
              showChat={this.state.showChat}
              toggleChat={this.toggleChat}
              toggleMenu={toggleMenu}
            />
          )}
        >
          <Switch>
            <Route
              path={'/profile'}
              render={() => <Profile {...this.props} sub={this.props.sub} />}
            />
            <Alert severity={'error'}>
              <AlertTitle style={{ fontWeight: 600 }}>Trial Expired</AlertTitle>
              <Typography color="inherit" variant="body2">
                Your Trial Period Expired. Please contact WeAdmit Admin.
              </Typography>
            </Alert>
          </Switch>
        </Layout>
      );
    }

    const activeSub = profile.subscriptions.find((s) => s.status === 'active');

    if (!activeSub && trialExpired) {
      const perpetualSub = profile.subscriptions.find(
        (s) => s.product.pricing_model === 'Perpetual',
      );
      return (
        <Layout
          role="student"
          navigations={StudentSidebar}
          renderHeader={({ toggleMenu }) => (
            <Navigation
              showChat={this.state.showChat}
              toggleChat={this.toggleChat}
              toggleMenu={toggleMenu}
            />
          )}
        >
          <Switch>
            <Route
              path={'/profile'}
              render={() => <Profile {...this.props} sub={this.props.sub} />}
            />
            <Alert
              severity={'error'}
              action={
                perpetualSub && (
                  <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to={`/profile/subscription`}
                  >
                    Subscribe again
                  </Button>
                )
              }
            >
              <AlertTitle style={{ fontWeight: 600 }}>
                Subscription Expired
              </AlertTitle>
              <Typography color="inherit">
                {perpetualSub
                  ? 'To access your account information, resubscribe to WeAdmit '
                  : 'Your Subscription has expired. Please contact WeAdmit Admin.'}
              </Typography>
            </Alert>
          </Switch>
        </Layout>
      );
    }

    if (profile.onboarding_done || onBoardingSkip === 'true') {
      const menuItems = [...this.props.content];
      if (profile.financial_aid_settings?.involve_child === '1') {
        menuItems.push({
          title: 'Financial Aid',
          url: '/financial-aid',
          icon: FinancialAidIcon,
        });
      }

      return (
        <Layout
          role="student"
          product={profile.product_type}
          navigations={
            profile.product_type === 'solo'
              ? SoloStudentSidebar
              : profile.product_type === 'cohort'
              ? CohortStudentSidebar
              : StudentSidebar
          }
          renderHeader={({ toggleMenu }) => (
            <>
              <Navigation
                showChat={this.state.showChat}
                toggleChat={this.toggleChat}
                toggleMenu={toggleMenu}
              />
            
            </>
          )}
        >
          <>
            <SharePopup />
            <Switch>
              <Route
                exact
                path="/todos"
                component={() => (
                  <Todo userId={this.props.user.id} sub={this.props.sub} />
                )}
              />
              <Route path="/timeline" component={Timeline} />
              <Route path="/team" component={Team} />
              <Route path="/stats" component={Stats} />
              <Route path="/files" component={FileManager} />
              <Route
                path="/financial-aid"
                render={(props) => (
                  <FinancialAid
                    {...props}
                    student={{
                      ...profile,
                      ...user,
                      name: user.fname + ' ' + user.lname,
                    }}
                    guardians={profile.guardians}
                  />
                )}
              />
              <Route
                path="/essays"
                render={(props) => (
                  <Essays
                    {...props}
                    student={{
                      ...this.props.user,
                      product_type: profile.product_type,
                    }}
                  />
                )}
              />
              <Route
                path="/schools"
                render={(props) => (
                  <School
                    student={{
                      ...this.props.user,
                      highschool_info: profile.highschool_info,
                    }}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path="/exercises/worksheet/:id"
                render={(props) => (
                  <ExerciseFrom {...props} studentId={user.id} />
                )}
              />
              <Route
                exact
                path="/exercises/:moduleId?"
                component={Worksheets}
              />
              <Route exact path={'/meeting/:roomId'} component={Meeting} />
              <Route
                exact
                path={'/meeting/group/:roomId'}
                component={(props) => <Meeting {...props} isGroup />}
              />
              <Route path="/notifications" component={NotificationPage} />
              <Route
                path="/snapshot"
                render={(props) => (
                  <SnapshotTable {...props} student={this.props.user} />
                )}
              />
              <Route
                path="/common-app"
                component={(props) => (
                  <CommonApp
                    {...props}
                    student={{
                      ...this.props.user,
                      product_type: profile.product_type,
                    }}
                  />
                )}
              />
              <Route
                path={'/profile'}
                render={() => <Profile {...this.props} sub={this.props.sub} />}
              />
              <Route
                path={'/onboarding'}
                render={() => (
                  <ProfileOnBoarding {...this.props} sub={this.props.sub} />
                )}
              />
              <Route path="/referral" component={Referral} />
              <Route
                path="/addons"
                render={(props) => (
                  <Upsell
                    {...this.props}
                    student={{
                      ...this.props.user,
                      product_type: this.props.profile.product_type,
                    }}
                  />
                )}
              />
              <Redirect from="/" to="/todos" />
            </Switch>
            {showVideo && profile.product_type === 'solo' && (
              <WelcomeVideo
                onClose={() => this.setState({ showVideo: false })}
              />
            )}
            {showVideo && profile.product_type === 'cohort' && (
              <WelcomeVideo
                onClose={() => this.setState({ showVideo: false })}
              />
            )}
            {!(
              pathname.includes('onboarding') || pathname.includes('meeting')
            ) && (
              <Fab
                color="primary"
                className={classes.fab}
                onClick={this.toggleChat}
              >
                <ForumIcon />
              </Fab>
            )}
          </>
        </Layout>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  profile: state.student.profile,
});

const mapDispatchToProps = {
  setStudentProfile,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Student));
